import React from 'react';
import type { IconProps } from '../types';

export const Dice = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      {/* Soft 3D-ish shading for the front face */}
      <linearGradient
        id="dice3d-body"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
      >
        <stop
          offset="0%"
          stopColor="#ffffff"
        />
        <stop
          offset="100%"
          stopColor="#e5e7eb"
        />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      {/* Back face for subtle 3D effect */}
      <rect
        x="5.5"
        y="3.5"
        width="13"
        height="13"
        rx="3"
        fill="#e5e7eb"
        opacity="0.6"
      />
      {/* Front face */}
      <rect
        x="4"
        y="5"
        width="14"
        height="14"
        rx="3"
        fill="url(#dice3d-body)"
        stroke="#9ca3af"
        strokeWidth="1"
      />
      {/* Pips - classic white dice with black dots */}
      <circle cx="9" cy="9" r="1.3" fill="#111827" />
      <circle cx="15" cy="15" r="1.3" fill="#111827" />
      <circle cx="9" cy="15" r="1.3" fill="#111827" />
      <circle cx="15" cy="9" r="1.3" fill="#111827" />
      <circle cx="12" cy="12" r="1.3" fill="#111827" />
    </g>
  </svg>
);

export default Dice;
